import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule, NgFor, DecimalPipe } from '@angular/common';
import { BaseChartDirective } from 'ng2-charts';
import { ChartData, ChartOptions, Chart, registerables } from 'chart.js';
import { HeaderComponent } from '../../shared/header/header.component';
import { EstoqueDashboardService } from '../../services/estoque-dashboard.service';
import { DashboardData } from '../../models/dashboard.model';

Chart.register(...registerables);

@Component({
  selector: 'app-dashboard-cadastro',
  standalone: true,
  imports: [CommonModule, BaseChartDirective, NgFor, DecimalPipe, HeaderComponent],
  templateUrl: './dashboard-cadastro.component.html',
  styleUrl: './dashboard-cadastro.component.scss'
})
export class DashboardCadastroComponent implements OnInit {

  carregando = true;
  erro: string | null = null;
  dashboardData: DashboardData | null = null;

  // Cards
  totalItens = 0;
  itensAtivos = 0;
  itensCriticos = 0;

  // ===== GRÁFICO 1: Distribuição por Status (BAR) — dados reais =====
  public distribuicaoChartData: ChartData<'bar'> = {
    labels: [],
    datasets: [{ label: 'Quantidade', data: [], backgroundColor: ['#20c997', '#ffc107', '#0073CF', '#e60000', '#9d9d9d'] }]
  };
  public distribuicaoChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: { y: { beginAtZero: true } }
  };
  temDistribuicao = false;

  // ===== GRÁFICO 2: Marcas Mais Usadas (BAR) — calculado dos itens reais =====
  public marcasChartData: ChartData<'bar'> = {
    labels: [],
    datasets: [{ label: 'Quantidade', data: [], backgroundColor: ['#0073CF', '#33a0e7', '#f7931e', '#20c997', '#e60000', '#9d9d9d'] }]
  };
  public marcasChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: { y: { beginAtZero: true } }
  };
  temMarcas = false;

  // Atividades recentes
  itensRecentes: { description: string; time: string }[] = [];

  constructor(
    public router: Router,
    private estoqueDashboardService: EstoqueDashboardService
  ) { }

  ngOnInit(): void {
    this.estoqueDashboardService.getDashboardData().subscribe({
      next: (data) => {
        this.dashboardData = data;
        this.carregando = false;
        this.montarCards(data);
        this.montarGraficoDistribuicao(data);
        this.montarGraficoMarcas(data);
        this.montarAtividades(data);
      },
      error: (err) => {
        this.erro = 'Erro ao carregar dados do dashboard. Verifique se a API está acessível.';
        this.carregando = false;
        console.error('Erro ao carregar DashboardCadastro:', err);
      }
    });
  }

  private montarCards(data: DashboardData): void {
    this.totalItens = data.metrics.totalEstoque;
    this.itensAtivos = data.itens.filter(i => i.ativo === true).length;
    this.itensCriticos = data.metrics.itensCriticos;
  }

  private montarGraficoDistribuicao(data: DashboardData): void {
    if (!data.distribution?.length) return;
    this.temDistribuicao = true;
    this.distribuicaoChartData = {
      labels: data.distribution.map(d => d.status),
      datasets: [{
        label: 'Quantidade',
        data: data.distribution.map(d => d.quantidade),
        backgroundColor: ['#20c997', '#ffc107', '#0073CF', '#e60000', '#9d9d9d']
      }]
    };
  }

  private montarGraficoMarcas(data: DashboardData): void {
    const contagem: Record<string, number> = {};
    data.itens.forEach(item => {
      const marca = item.marca?.nome ?? 'Outros';
      contagem[marca] = (contagem[marca] ?? 0) + 1;
    });
    const entradas = Object.entries(contagem).sort((a, b) => b[1] - a[1]).slice(0, 6);
    if (!entradas.length) return;
    this.temMarcas = true;
    this.marcasChartData = {
      labels: entradas.map(e => e[0]),
      datasets: [{
        label: 'Quantidade',
        data: entradas.map(e => e[1]),
        backgroundColor: ['#0073CF', '#33a0e7', '#f7931e', '#20c997', '#e60000', '#9d9d9d']
      }]
    };
  }

  private montarAtividades(data: DashboardData): void {
    this.itensRecentes = [...data.itens]
      .sort((a, b) => new Date(b.dataCadastro).getTime() - new Date(a.dataCadastro).getTime())
      .slice(0, 5)
      .map(item => ({
        description: `"${item.descricao}" (#${item.exbePatrimonioId}) cadastrado.`,
        time: new Date(item.dataCadastro).toLocaleDateString('pt-BR')
      }));
  }
}